import { useMutation } from '@tanstack/react-query';

import {
  CreateCreditSecurePaymentLinkPayload,
  CreateCreditSecurePaymentLinkResponse,
  createCreditSecurePaymentLink,
} from '~/services/PaymentsService';

const CREDIT_SECURE_PAYMENT_LINK_BASE_KEY = 'creditSecurePaymentLink' as const;

export const creditSecurePaymentLinkKeys = {
  all: [CREDIT_SECURE_PAYMENT_LINK_BASE_KEY] as const,
  mutations: {
    create: [CREDIT_SECURE_PAYMENT_LINK_BASE_KEY, 'create'] as const,
  },
};

export function useCreateCreditSecurePaymentLink() {
  return useMutation<CreateCreditSecurePaymentLinkResponse, Error, CreateCreditSecurePaymentLinkPayload>({
    mutationKey: creditSecurePaymentLinkKeys.mutations.create,
    mutationFn: (payload: CreateCreditSecurePaymentLinkPayload) => createCreditSecurePaymentLink(payload),
  });
}
